module.exports = __webpack_public_path__ + "media/images/category/dummy/tops05-764a8a2328c4a6c560fe084b1456df50.jpg";